var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function Arrow10IconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5858 6H13C12.4477 6 12 5.55228 12 5C12 4.44772 12.4477 4 13 4H19C19.5523 4 20 4.44772 20 5V11C20 11.5523 19.5523 12 19 12C18.4477 12 18 11.5523 18 11V7.41421L7.41421 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H5C4.44772 20 4 19.5523 4 19V13C4 12.4477 4.44772 12 5 12C5.55228 12 6 12.4477 6 13V16.5858L16.5858 6Z", fill: "" })));
}
export var Arrow10Icon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: Arrow10IconInner }, props))); };
//# sourceMappingURL=Arrow10Icon.js.map